@if (items && items.length > 0) {
  <div class="flex justify-content-center mt-2 mb-2" style="border: none;">
    <!-- Breadcrumb when items are available -->
    <p-breadcrumb class="no-border max-w-full" [model]="items" [home]="home"></p-breadcrumb>
  </div>
}
<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Artist Info Section -->
    <div class="col-md-12">
      @if (ConsignmentProposalProduct.length > 0 && ConsignmentProposalProduct[0].ConsignmentProposal) {
        <div class="bg-white rounded shadow-sm p-2 my-2"
          >
          <!-- Top Section: Artist Info and See More -->
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-3 bg-light p-2 rounded">
            <div class="d-flex align-items-center flex-wrap gap-3">
              @if (ConsignmentProposalProduct[0].ConsignmentProposal.ArtistName) {
                <img [src]="ConsignmentProposalProduct[0].ConsignmentProposal.ArtistImgUrl"
                  class="rounded-circle border" height="56" width="56"
                  style="object-fit: cover; cursor: pointer;"
                  (click)="viewArtistDetails(ConsignmentProposalProduct[0].ConsignmentProposal.ArtistUserName)"
                  [alt]="'proposalSelection.artistImage' | transloco" />
              }
              <div class="ms-2">
                <a class="" href="javascript:void(0);"
                  (click)="viewArtistDetails(ConsignmentProposalProduct[0].ConsignmentProposal.ArtistUserName)">
                  {{ ConsignmentProposalProduct[0].ConsignmentProposal.ArtistName }}
                </a>
                <small class="text-secondary d-block">
                  @if (ConsignmentProposalProduct[0].ConsignmentProposal.ArtistBusinessName) {
                    <span>
                      {{ 'proposalSelection.tradingAs' | transloco: { name: ConsignmentProposalProduct[0].ConsignmentProposal.ArtistBusinessName } }}
                    </span>
                  }
                  @if ((ConsignmentProposalProduct[0].ConsignmentProposal.NumberOfConsignmentProducts ?? 0) > 0) {
                    <span
                      class="ms-3">
                      {{ 'proposalSelection.artworksOnHand' | transloco: { count: ConsignmentProposalProduct[0].ConsignmentProposal.NumberOfConsignmentProducts } }}
                    </span>
                  }
                </small>
              </div>
            </div>
            <button
              class="d-flex align-items-center gap-1 text-secondary border-0 bg-light rounded shadow-sm px-3 py-2 mt-3 mt-md-0"
              (click)="onShowArtistOverlay(ConsignmentProposalProduct[0].ConsignmentProposal.ArtistId)"
              type="button">
              {{ 'proposalSelection.seeMore' | transloco }} <i class="pi pi-chevron-down fs-5"></i>
            </button>
          </div>
          <!-- Proposal Title and Action Buttons in Same Row -->
          <div class="row align-items-end g-3">
            <!-- Proposal Title -->
            <div class="col-12 col-md-8">
              <label class="form-label fw-semibold fs-5 mt-2">{{ 'proposalSelection.proposalTitle' | transloco }}</label>
              <div class="text-body">
                {{ ConsignmentProposalProduct[0].ConsignmentProposal.Title || 'No title provided' }}
              </div>
            </div>
            <!-- Buttons -->
            <div class="col-12 col-md-4 d-flex flex-wrap justify-content-md-end gap-2">
              <a class="btn btn-outline-secondary flex-fill flex-md-grow-0"
                [href]="'/profile/' + ConsignmentProposalProduct[0].ConsignmentProposal.ArtistUserName"
                [attr.disabled]="!ConsignmentProposalProduct[0].ConsignmentProposal.IsShowArtistPublicProfile ? true : null"
                target="_blank">
                {{ 'proposalSelection.viewProfile' | transloco }}
              </a>
              <a class="btn btn-outline-secondary flex-fill flex-md-grow-0"
                [href]="'/artist/' + ConsignmentProposalProduct[0].ConsignmentProposal.ArtistId"
                [attr.disabled]="!ConsignmentProposalProduct[0].ConsignmentProposal.IsIncludeArtistAvailableInventory ? true : null"
                target="_blank">
                {{ 'proposalSelection.viewInventory' | transloco }}
              </a>
              <button class="btn btn-outline-secondary flex-fill flex-md-grow-0"
                (click)="onShowArtistOverlay(ConsignmentProposalProduct[0].ConsignmentProposal.ArtistId)"
                type="button">
                {{ 'proposalSelection.viewStats' | transloco }}
              </button>
            </div>
          </div>
          <!-- Proposal Description -->
          <div class="mt-4">
            <label class="form-label fs-5 fw-semibold">{{ 'proposalSelection.proposalDescription' | transloco }}</label>
            <div class="text-body" style="white-space: pre-wrap;">
              {{ ConsignmentProposalProduct[0].ConsignmentProposal.Description || 'No description provided' }}
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Rest of the template -->
    <div class="row g-2 mt-2">
      <!-- Available Artworks (Left Side) -->
      <div class="col-lg-9">
        <div class="available-artworks p-3 bg-white rounded shadow-sm h-100"
          style="overflow-y: auto; max-height: 800px; border: 1px solid #eee;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="fw-bold text-secondary m-0">
              <i class="pi pi-images me-2" style="color:#007bff;"></i>
              {{ 'proposalSelection.availableArtworks' | transloco }}
              @if (availableProducts.length) {
                <span class="text-muted fs-6">
                  ({{ availableProducts.length }})
                </span>
              }
            </h5>
          </div>

          <div class="row g-2">
            @for (product of availableProducts; track product) {
              <div class="col-2">
                <div class="artwork-card rounded shadow-sm bg-light border cursor-pointer p-1 d-flex flex-column align-items-center transition-scale"
                  (click)="selectProduct(product)"
                  [title]="'Click to select ' + product.ArtistProduct_Name">
                  <div class="image-wrapper position-relative w-100">
                    <img [src]="product.ArtistProduct_ProductImgUrl || 'assets/images/No-Image.png'"
                      alt="{{product.ArtistProduct_Name}}"
                      class="img-fluid h-100 w-100 object-fit-contain" style="object-fit: contain;">
                      <i class="fa fa-info-circle position-absolute top-0 end-0 m-2 text-dark fs-4"
                        style="cursor: pointer;"
                        (click)="openProductDialog(product.ArtistProductId); $event.stopPropagation()"
                      [title]="'proposalSelection.viewDetails' | transloco"></i>
                    </div>
                    <div class="text-center py-1 w-100">
                      <h6 class="text-truncate text-uppercase fw-semibold mb-1"
                        style="font-size: 0.9rem;">
                        {{ product.ArtistProduct_Name }}
                      </h6>
                    </div>
                  </div>
                </div>
              }

              @if (availableProducts.length === 0) {
                <div class="text-center text-muted py-5 w-100">
                  <i class="pi pi-image fs-3 mb-2"></i>
                  <div>{{ 'proposalSelection.noArtworksFound' | transloco }}</div>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Selected Artworks (Right Side) - Updated to match the first design -->
        <div class="col-lg-3 d-flex flex-column">
          <div class="selected-artworks p-3 bg-light rounded shadow-sm h-100 d-flex flex-column"
            style="border: 1px solid #eee;">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="fw-bold text-secondary m-0">
                <i class="pi pi-shopping-cart me-2" style="color:#007bff;"></i>
                {{ 'proposalSelection.selectedArtworks' | transloco }}
                @if (acceptedProducts.length > 0) {
                  <span class="text-muted fs-6">
                    ({{ acceptedProducts.length }})
                  </span>
                }
              </h5>
            </div>
            <div class="d-flex border-bottom justify-content-between py-2 me-2 mt-auto">
              <!-- Accept Button -->
              <div class="flex-fill">
                <Button pButton type="button" icon="fa fa-check-circle" [label]="'proposalSelection.accept' | transloco"
                class="p-button-outlined p-button-success w-100"
                [disabled]="acceptedProducts.length === 0" (click)="showCommentsDialog(true)">
              </Button>
            </div>

            <!-- Decline Button -->
            <div class="flex-fill">
              <Button pButton type="button" icon="fa fa-times" [label]="'proposalSelection.decline' | transloco"
              class="p-button-outlined p-button-danger w-100 ms-2" severity="danger"
              [disabled]="acceptedProducts.length === 0" (click)="showRejectDialog(false)">
            </Button>
          </div>
        </div>

        <!-- Helping Text -->
        <div class="alert alert-warning p-3 rounded mt-2 small mb-3 rounded" style="font-style: italic;">
          💡 <strong>{{ 'proposalSelection.tipLabel' | transloco }}</strong> {{ 'proposalSelection.tipText1' | transloco }} <strong>{{ 'proposalSelection.tipAccept' | transloco }}</strong>{{ 'proposalSelection.tipText2' | transloco }}
          <strong>{{ 'proposalSelection.tipDeclined' | transloco }}</strong>.
        </div>

        <!-- Selected Artworks Grid - Similar to the first design -->
        <div class="row g-2 flex-grow-1" style="overflow-y: auto;">
          @for (product of acceptedProducts; track product) {
            <div class="col-6">
              <div class="artwork-card rounded shadow-sm bg-white border cursor-pointer p-1 d-flex flex-column align-items-center transition-scale mb-2"
                (click)="removeAcceptedProduct(product); $event.stopPropagation()"
                [title]="'Click to remove ' + product.ArtistProduct_Name">
                <div class="image-wrapper position-relative w-100">
                  <img [src]="product.ArtistProduct_ProductImgUrl || 'assets/images/No-Image.png'"
                    alt="{{product.ArtistProduct_Name}}"
                    class="img-fluid h-100 w-100 object-fit-contain" />
                    <i class="fa fa-info-circle position-absolute top-0 end-0 m-2 text-dark fs-4"
                      style="cursor: pointer;"
                      (click)="openProductDialog(product.ArtistProductId); $event.stopPropagation()"
                    [title]="'proposalSelection.viewDetails' | transloco"></i>
                  </div>
                  <div class="text-center py-1 w-100">
                    <h6 class="text-truncate text-uppercase fw-semibold mb-1"
                      style="font-size: 0.85rem;">
                      {{ product.ArtistProduct_Name }}
                    </h6>
                  </div>
                </div>
              </div>
            }

            @if (acceptedProducts.length === 0) {
              <div class="text-center text-muted py-5 w-100">
                <i class="pi pi-info-circle fs-3 mb-2"></i>
                <div>{{ 'proposalSelection.noArtworksSelected' | transloco }}</div>
              </div>
            }
          </div>


        </div>
      </div>
    </div>
  </div>
</div>

<!-- Accept Proposal Dialog -->
<p-dialog [header]="'proposalSelection.comments' | transloco" [showHeader]="true" [(visible)]="showAddCommentsDialog" [modal]="true"
  [style]="{'width': '560px'}" (onHide)="closeAddCommentsDialog($event)">
  <div class="form-group my-3">
    <div class="panel-container">
      <div class="panel-body">
        <!-- Reject Comments Textarea -->
        <div class="form-group position-relative">
          <label for="comments" class="form-label">{{ 'proposalSelection.yourComments' | transloco }}</label>
          <textarea id="comments" pInputTextarea rows="6" cols="6" name="comments"
            [(ngModel)]="galleryComment" [placeholder]="'proposalSelection.optionalComments' | transloco"
          class="form-control"></textarea>
          <!-- Emoji Picker for Reject Comments -->
          <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog('reject')"
            style="top: 75%; right: 0.5rem; transform: translateY(-50%);">
            (😍)
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Accept Button -->
  <button pButton type="button" class="p-button-primary p-button-outlined w-100 mt-4" [label]="'proposalSelection.accept' | transloco"
    (click)="continueAcceptanceOrRejection($event)">
  </button>
</p-dialog>

<!-- Reject Proposal Dialog -->
<p-dialog [header]="'proposalSelection.comments' | transloco" [showHeader]="true" [(visible)]="showRejectProposalDialog" [modal]="true"
  [style]="{'width': '560px'}" (onHide)="closeAddCommentsDialog($event)">
  <form class="form-horizontal mt-2 px-3">
    <div class="text-muted small">
      <i class="fa fa-info-circle me-1"></i> {{ 'proposalSelection.addCommentsInfo' | transloco }}
    </div>
    <div class="form-group my-3">
      <div class="panel-container">
        <div class="panel-body">
          <!-- Reject Comments Textarea -->
          <div class="form-group position-relative">
            <label for="comments" class="form-label">{{ 'proposalSelection.yourComments' | transloco }}</label>
            <textarea id="comments" pInputTextarea rows="6" cols="6" name="comments"
              [(ngModel)]="galleryComment" [placeholder]="'proposalSelection.optionalComments' | transloco"
            class="form-control"></textarea>
            <!-- Emoji Picker for Reject Comments -->
            <div class="emoji-icon position-absolute cursor-pointer fs-6"
              (click)="openEmojiDialog('reject')"
              style="top: 75%; right: 0.5rem; transform: translateY(-50%);">
              (😍)
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Decline Button -->
    <button pButton type="button" class="p-button-primary p-button-outlined w-100 mt-4" [label]="'proposalSelection.decline' | transloco"
      (click)="rejectProposal()">
    </button>
  </form>
</p-dialog>

<!-- Emoji Dialog -->
@if (displayEmojiDialog) {
  <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
    (emojiClick)="addEmoji($event)">
  </app-emoji-list>
}

@if (showArtistOverlayPanel) {
  <artist-overlay [visible]="showArtistOverlayPanel" [artistId]="artistId"
    [showSalesHistory]="ConsignmentProposalProduct[0].ConsignmentProposal?.IsIncludeArtistSalesHistory ?? false"
    (onClosed)="onArtistOverlayClosed($event)">
  </artist-overlay>
}

@if (showProductDialog) {
  <app-product-details-dialog [showProductDialog]="showProductDialog" [productId]="productId"
    (onClose)="closeProductDialog()">
  </app-product-details-dialog>
}

<!-- Accept Proposal Dialog -->
<p-dialog [header]="'proposalSelection.comments' | transloco" [showHeader]="true" [(visible)]="showAddCommentsDialog" [modal]="true"
  [style]="{'width': '560px'}" (onHide)="closeAddCommentsDialog($event)">
  <div class="form-group my-3">
    <div class="panel-container">
      <div class="panel-body">
        <!-- Reject Comments Textarea -->
        <div class="form-group position-relative">
          <label for="comments" class="form-label">{{ 'proposalSelection.yourComments' | transloco }}</label>
          <textarea id="comments" pInputTextarea rows="6" cols="6" name="comments"
            [(ngModel)]="galleryComment" [placeholder]="'proposalSelection.optionalComments' | transloco"
            class="form-control">
          </textarea>
          <!-- Emoji Picker for Reject Comments -->
          <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog('reject')"
            style="top: 75%; right: 0.5rem; transform: translateY(-50%);">
            (😍)
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Accept Button -->
  <button pButton type="button" class="p-button-primary p-button-outlined w-100 mt-4" [label]="'proposalSelection.accept' | transloco"
    (click)="continueAcceptanceOrRejection($event)">
  </button>
</p-dialog>
<!-- Reject Proposal Dialog -->
<p-dialog [header]="'proposalSelection.comments' | transloco" [showHeader]="true" [(visible)]="showRejectProposalDialog" [modal]="true"
  [style]="{'width': '560px'}" (onHide)="closeAddCommentsDialog($event)">
  <form class="form-horizontal mt-2 px-3">
    <div class="text-muted small">
      <i class="fa fa-info-circle me-1"></i> {{ 'proposalSelection.addCommentsInfo' | transloco }}
    </div>
    <div class="form-group my-3">
      <div class="panel-container">
        <div class="panel-body">
          <!-- Reject Comments Textarea -->
          <div class="form-group position-relative">
            <label for="comments" class="form-label">{{ 'proposalSelection.yourComments' | transloco }}</label>
            <textarea id="comments" pInputTextarea rows="6" cols="6" name="comments"
              [(ngModel)]="galleryComment" [placeholder]="'proposalSelection.optionalComments' | transloco"
              class="form-control">
            </textarea>
            <!-- Emoji Picker for Reject Comments -->
            <div class="emoji-icon position-absolute cursor-pointer fs-6"
              (click)="openEmojiDialog('reject')"
              style="top: 75%; right: 0.5rem; transform: translateY(-50%);">
              (😍)
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Decline Button -->
    <button pButton type="button" class="p-button-primary p-button-outlined w-100 mt-4" [label]="'proposalSelection.decline' | transloco"
      (click)="rejectProposal()">
    </button>
  </form>
</p-dialog>
<!-- Emoji Dialog -->
@if (displayEmojiDialog) {
  <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
    (emojiClick)="addEmoji($event)">
  </app-emoji-list>
}


<!-- <ng-container *ngIf="showArtistOverlayPanel">
<artist-overlay [visible]="showArtistOverlayPanel" [artistId]="artistId" (onClosed)="onArtistOverlayClosed($event)">
</artist-overlay>
</ng-container> -->

@if (showArtistOverlayPanel) {
  <artist-overlay [visible]="showArtistOverlayPanel" [artistId]="artistId"
    [showSalesHistory]="ConsignmentProposalProduct[0].ConsignmentProposal?.IsIncludeArtistSalesHistory ?? false"
    (onClosed)="onArtistOverlayClosed($event)">
  </artist-overlay>
}

@if (showProductDialog) {
  <app-product-details-dialog [showProductDialog]="showProductDialog" [productId]="productId"
    (onClose)="closeProductDialog()">
  </app-product-details-dialog>
}